







/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { StringHelper } from '@fruitpackage/helpers';
import { applyConfig } from '@config';
import { FileService } from '@store/service/FileService';
import { ApplyMixin } from '@mixin';

import ApplicantIntro from '@part/steps/applicant/Intro';
import ApplicantAanvrager from '@part/steps/applicant/Aanvrager';
import ApplicantKiesOrganisatie from '@part/steps/applicant/KiesOrganisatie';
import ApplicantVindOrganisatie from '@part/steps/applicant/VindOrganisatie';
import ApplicantMaakOrganisatie from '@part/steps/applicant/MaakOrganisatie';
import ApplicantCommunityToegestaan from '@part/steps/applicant/CommunityToegestaan';
import ApplicantCommunityAfgewezen from '@part/steps/applicant/CommunityAfgewezen';
import ApplicantMaakCommunity from '@part/steps/applicant/MaakCommunity';

import ApplicantKvk from '@part/steps/applicant/Kvk';
import ApplicantTekenbevoegdVereist from '@part/steps/applicant/TekenbevoegdVereist';
import ApplicantTekenbevoegdVraag from '@part/steps/applicant/TekenbevoegdVraag';
import ApplicantTekenbevoegd from '@part/steps/applicant/Tekenbevoegd';
import ApplicantAddContactQuestion from '@part/steps/applicant/AddContactQuestion';
import ApplicantAddContact from '@part/steps/applicant/AddContact';

import ApplicantStatutenVereist from '@part/steps/applicant/StatutenVereist';
import ApplicantStatuten from '@part/steps/applicant/Statuten';
import ApplicantJaarrekening from '@part/steps/applicant/Jaarrekening';

import ProjectAandachtsgebied from '@part/steps/project/Aandachtsgebied';
import ProjectAanvang from '@part/steps/project/Aanvang';
import ProjectCrowdfunding from '@part/steps/project/Crowdfunding';
import ProjectDeclined from '@part/steps/project/Declined';
import ProjectProjectplan from '@part/steps/project/Projectplan';
import ProjectBegroting from '@part/steps/project/Begroting';
import ProjectOffertes from '@part/steps/project/Offertes';
import ProjectBedrag from '@part/steps/project/Bedrag';

import ConfirmationBevestig from '@part/steps/confirmation/Bevestig';
import ConfirmationKlaar from '@part/steps/confirmation/Klaar';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    mixins: [
        ApplyMixin,
    ],

    components: {
        ApplicantIntro,
        ApplicantAanvrager,
        ApplicantKiesOrganisatie,
        ApplicantVindOrganisatie,
        ApplicantMaakOrganisatie,
        ApplicantCommunityToegestaan,
        ApplicantCommunityAfgewezen,
        ApplicantMaakCommunity,
        
        ApplicantKvk,
        ApplicantTekenbevoegdVereist,
        ApplicantTekenbevoegdVraag,
        ApplicantTekenbevoegd,

        ApplicantAddContactQuestion,
        ApplicantAddContact,
        ApplicantStatutenVereist,
        ApplicantStatuten,
        ApplicantJaarrekening,

        ProjectAandachtsgebied,
        ProjectAanvang,
        ProjectCrowdfunding,
        ProjectDeclined,
        ProjectProjectplan,
        ProjectBegroting,
        ProjectOffertes,
        ProjectBedrag,
        
        ConfirmationBevestig,
        ConfirmationKlaar,
    },

    computed: {
        stepComponent() {
            return StringHelper.pascalCase(this.groupKey + '-' + this.stepKey);
        },
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            const validate = vm.validateRoute(to);
            if (!validate.valid)
                next(validate.redirect);
        });
    },

    beforeRouteUpdate (to, from, next) {
        const validate = this.validateRoute(to);

        if (from.fullPath === validate.redirect) {
            next(false);
        } else if (!validate.valid) {
            next(validate.redirect);
        } else {
            next();
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ApplyStep extends Vue {}

